module.exports = __webpack_public_path__ + "components/intersport-discount-page/promo-article/static/article-image@2-903ec1bf857499c2e649dbd5e2f2f04a.webp";